import { FaChevronLeft } from 'react-icons/fa';

export const PageWrapper = ({onGoBack,children,title}) => {
  return (
    <>
    <div className="h-[100dvh] w-[100dvw] bg-white p-6 px-12 shadow-[0px_2px_40px_0px_rgba(0,0,0,0.3)] fixed bottom-0 left-0 right-0 z-50 border-t-2 border-gray-200 overflow-y-auto pt-20">
      <button type="button" className="top-6 left-6 text-[#727272] flex items-center justify-center gap-2 geomanistMedium text-2xl" onClick={onGoBack}>
        <FaChevronLeft size={18} className="fill-[#727272]" />
        Retour
      </button>
      <h1 className="text-3xl geomanistMedium font-medium w-full text-start my-12 appear">{title}</h1>
      <div className="appear"> {children} </div>
    </div>
    </>
  );
};